module.exports = __webpack_public_path__ + "img/whistle.66442f1c.png";